import React, { useState } from "react";
import { Flex, Spin, Button, Modal, Input, Form, Row, Col, Select } from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import CustomHeader from "../CustomHeader/CustomHeader";
import APIService from "../../Service/APIService";
import Swal from "sweetalert2";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import TitleBar from "../../common/title-bar/title-bar";
import { colors } from "../../theme/colors";
import {useAuth} from '../AuthProvider.js';

const ASUsers = () => {
  const { user, isReady } = useAuth();
  const userData = user;
  const [modalVisible, setModalVisible] = useState(false);
  const [userType, setUserType] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const components = {
    header: {
      cell: ({ style, ...restProps }) => (
        <th
          {...restProps}
          style={{
            ...style,
            backgroundColor: "#000a7b",
            color: "#fff",
          }}
        />
      ),
    },
    body: {
      cell: ({ style, ...restProps }) => (
        <td
          {...restProps}
          style={{
            ...style,
            padding: "8px", // Adjust padding here
          }}
        />
      ),
      // row: ({ children, ...restProps }) => (
      //   <tr {...restProps}>
      //     {React.Children.map(children, (child) => (
      //       <td {...child.props}>
      //         <div style={{ marginBottom: '10px' }}>{child.props.children}</div>
      //       </td>
      //     ))}
      //   </tr>
      // ),
    },
  };

  const handleNew = () => {
    setModalVisible(true);
  };

  const handleModalOk = () => {
    setModalVisible(false);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const [ASUsers, setASUsers] = useState([]);

  const getASUsers = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getasusers");
    console.log("AS Users: ", response);
    return response?.data?.data;
  };

  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("Admin");

  const registerUser = async () => {
    console.log("Register User Called");
    console.log("Selected Regions: ", selectRegionArray);
    // return;
    let isValidate = true;
    if (!fName || !lName || !email || !phone || !role) {
      isValidate = false;
    }
    if (!isValidate) {
      Swal.fire({
        title: "Error!",
        text: "Please fill all the fields",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("Register User");
        const postObj = {
          FirstName: fName,
          LastName: lName,
          Email: email,
          Phone: phone,
          RoleType: role,
          Username: fName + lName,
          Password: "Password",
          Type: role,
          RegionID: selectedRegion?.value,
          RegionName: selectedRegion?.label,
          RegionIDArray: selectRegionArray?.map((region) => region.value),
        };
        console.log("Post Obj: ", postObj);
        // return ;
        const apiServe = new APIService();
        const response = await apiServe.updateDataToBackend(
          postObj,
          "register"
        );
        console.log("Register User: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire({
            title: "Success!",
            text: "User Added Successfully",
            icon: "success",
            confirmButtonText: "Ok",
          });
          setModalVisible(false);
          getASUsers();
        } else {
          Swal.fire({
            title: "Error!",
            text: "Error while adding user",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      }
    });
  };

  const [regionsData, setRegionsData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectRegionArray, setSelectRegionArray] = useState([]);

  const getRegionData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getallregions");
    console.log("Regions: ", response);
    const tempData = response?.data?.data?.map((region) => ({
      value: region.ID,
      label: region.Region,
    }));
    setRegionsData(tempData);
  };

  React.useEffect(() => {
    console.log("AS Users component mounted");
    const userData = user;
    if(userData.Type !== "Admin" && userData.Type !== "ASD" && userData.Type !== "Authorizer" && userData.Type !== "Viewer") {
      window.location.href = "/";
    }
    setUserType(userData?.Type);
    getRegionData();
    getASUsers()
      .then((data) => {
        console.log("AS Users: ", data);
        const tempData = data.map((user) => ({
          ...user,
          Name: `${user.FirstName} ${user.LastName}`,
          RoleType: user.RoleType ? (
            <Button
              type="default"
              shape="round"
              size="small"
              style={{
                color: colors["primaryColor"],
                borderColor: colors["primaryColor"],
                width: "100%",
              }}
            >
              {user.RoleType}
            </Button>
          ) : null,
          Region: user.RegionName ? (
            <Button
              type="default"
              shape="round"
              size="small"
              style={{
                color: colors["primaryColor"],
                borderColor: colors["primaryColor"],
                width: "100%",
              }}
            >
              {user.RegionName}
            </Button>
          ) : null,
        }));
        setASUsers(tempData);
      })
      .then(() => {
        setLoading(false);
      });
  }, []);
  console.log(ASUsers, "as users >>>>>1");
  return (
    <div>
      {/* <CustomHeader leftTopText="Welcome back!" leftBottomText="AS Users" leftBottomExtraText=""
        rightTopText="Logged in as Admin" rightBottomText="User" /> */}
      <TitleBar
        label="AS Users"
        rightFilterBarComponents={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Input
              placeholder="Search"
              suffix={<SearchOutlined />}
              style={{ marginRight: "20px", height: "36px" }}
            />
            {userType !== "Authorizer" && userType !== "Viewer" && (
              <Button
                onClick={handleNew}
                type="primary"
                style={{ background: colors["primaryColor"] }}
                icon={<PlusOutlined />}
                iconPosition="start"
              >
                New
              </Button>
            )}
          </div>
        }
      />
      {/* <Table columns={columnsASUsers} dataSource={ASUsers} pagination={true} components={components} /> */}
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      {!loading && (
        <GenericDashboard data={ASUsers} screen="ASUsersDashboard" />
      )}
      <Modal
        title="Add New AS User"
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        footer={null}
        centered={true}
      >
        {/* <div style={{ padding: '0px 20px 20px 20px' }}> */}
        <div>
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="First Name">
                  <Input
                    placeholder="Enter First Name"
                    value={fName}
                    onChange={(e) => setFName(e.target.value)}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Last Name">
                  <Input
                    placeholder="Enter Last Name"
                    value={lName}
                    onChange={(e) => setLName(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Email">
                  <Input
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Phone">
                  <Input
                    placeholder="Enter Phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Role">
                  <Select
                    defaultValue="Admin"
                    options={[
                      { value: "Admin", label: "Admin" },
                      { value: "ASD", label: "ASD" },
                      { value: "Authorizer", label: "Authorizer" },
                      { value: "Viewer", label: "Viewer" },
                    ]}
                    onChange={(value) => setRole(value)}
                  />
                </Form.Item>
              </Col>
              {role === "ASD" && (
                <Col span={12}>
                  <Form.Item label="Region">
                    <Select
                      // defaultValue="Admin"
                      options={regionsData}
                      onChange={(value, option) => setSelectedRegion(option)}
                    />
                  </Form.Item>
                </Col>
              )}
              {/* {role === "Viewer" && (
                <Col span={12}>
                  <Form.Item label="Region">
                    <Select
                      // defaultValue="Admin"
                      options={regionsData}
                      onChange={(value, option) => setSelectRegionArray(option)}
                      mode="multiple"
                    />
                  </Form.Item>
                </Col>
              )} */}
            </Row>

            <p style={{ marginTop: "0px" }}>
              Adding and activating an AS contact gives them access to Tissue
              Vault.
            </p>
            <Button
              type="primary"
              style={{ background: "#27a907" }}
              onClick={registerUser}
            >
              Add and Activate
            </Button>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default ASUsers;
